import { Table, TableBody, TableContainer } from '@mui/material'
import DashboardTableHeads from './DashboardTableHead'
import DashboardRowRender from '../RowRender/DashboardRowRender'

const DashboardOrdersTable = ({ orders }: any) => (
  <TableContainer sx={{ overflowX: !orders?.length ? 'hidden' : null }}>
    <Table
      sx={{ '& .MuiTableCell-root': { paddingLeft: 0, paddingRight: 0 } }}
      aria-labelledby="tableTitle"
      size="medium"
    >
      <DashboardTableHeads />
      <TableBody>
        <DashboardRowRender rows={orders} />
      </TableBody>
    </Table>
  </TableContainer>
)

export default DashboardOrdersTable
